
export default
	computed:
		hasTopBorder: -> @$store.state.tower?.darkLastBlock
		classes: -> [
			"top-border" if @hasTopBorder
			"is-en" if @isEn
		]
		isEn: -> @$i18n.locale == 'en'
		availableSites: -> @$store.state.localization?.availableSites
		showLanguageSelector: -> @availableSites?.length > 1

